import apiFetch from '../apiFetch'

export default function (dossierId, token) {
  return apiFetch({
    endPoint: `dossier/campaign/${dossierId}/header`,
    method: 'GET',
    body: null,
    token: token
  })
}
